import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../theme';

const PresetPreviewBrowser = styled.div`
  border-radius: ${theme.unit * 2}px;
  height: 100%;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    display: block;
    height: 0;
    padding-bottom: 100%;
    width: 100%;
  }
`;

const PresetAddressBar = styled.div`
  background: ${theme.colors.gray16};
  box-sizing: border-box;
  font-size: 15px;
  height: ${theme.unit * 6}px;
  left: 0;
  line-height: ${theme.unit * 6}px;
  position: absolute;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 1;

  * {
    position:relative;
    z-index: 1;
  }

  &::before {
    background: ${theme.colors.gray15};
    border-radius: ${theme.unit}px;
    bottom: ${theme.unit * 1.25}px;
    content: '';
    display: block;
    left: ${theme.unit * 1.25}px;
    position:absolute;
    right: ${theme.unit * 1.25}px;
    top: ${theme.unit * 1.25}px;
  }
`;

const PresetWindow = styled.div`
  align-items: center;
  background: ${theme.colors.black};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position:absolute;
  right: 0;
  top: ${theme.unit * 6}px;
  z-index: 0;
`;

const PresetDocument = styled.div`
  max-height: 100%;
  max-width: 100%;
`;

const PreviewImage = styled.img`
  background-image:
    linear-gradient(45deg, ${theme.colors.gray17} 25%, transparent 25%),
    linear-gradient(-45deg, ${theme.colors.gray17} 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, ${theme.colors.gray17} 75%),
    linear-gradient(-45deg, transparent 75%, ${theme.colors.gray17} 75%);
  background-position: 0 0, 0 ${theme.unit * 1.25}px, ${theme.unit * 1.25}px -${theme.unit * 1.25}px, -${theme.unit * 1.25}px 0px;
  background-size: ${theme.unit * 2.5}px ${theme.unit * 2.5}px;
  background: white;
  box-shadow: 0 0 0 1px ${theme.colors.black};
  width: 100%;
`;

const PresetPreview = ({ url, src, children }) => (
  <PresetPreviewBrowser>
    <PresetAddressBar>
      <span>{(url || '').replace(/^https?:\/\//, '')}</span>
    </PresetAddressBar>
    <PresetWindow>
      <PresetDocument>
        {src && !children && (
          <PreviewImage
            alt="preview"
            src={src}
          />
        )}
        {children}
      </PresetDocument>
    </PresetWindow>
  </PresetPreviewBrowser>
);
PresetPreview.propTypes = {
  url: PropTypes.string,
  src: PropTypes.string,
  children: PropTypes.node,
};
PresetPreview.defaultProps = {
  url: null,
  src: null,
  children: null,
};

export default PresetPreview;



// WEBPACK FOOTER //
// ./src/components/blocks/PresetPreview.js